import { useSelector } from 'react-redux';
import { isNylPilotAdvisor, SessionType } from '@shared';
import { selectFeatureFlags, selectSession } from '@/model/selectors';

/**
 * Whether the advisor's pilot program is New York Life. Resolves through the program precedence in
 * `PILOT_PROGRAMS`, so an advisor carrying several program flags counts as NYL only when NYL is
 * the program that wins. Client sessions read the flags of the advisor they belong to.
 */
export function useIsNylPilotAdvisor() {
  const featureFlags = useSelector(selectFeatureFlags);
  return isNylPilotAdvisor(featureFlags);
}

export function useIsNylPilotClientCreationRestricted() {
  const session = useSelector(selectSession);
  const featureFlags = useSelector(selectFeatureFlags);
  return (
    session.sessionType === SessionType.advisor &&
    isNylPilotAdvisor(featureFlags) &&
    !!featureFlags.nylPilotClientCreationRestricted
  );
}
